import React from "react";
import { Button, Card, Table } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { stockReport } from "../../../../../urls";
import { useProducts } from "../../../../../data/hooks/firestore/useProducts";
import { useStockReport } from "../../../../../data/hooks/firestore/useStockReport";
import { formatWeight } from "../../../../../functions/formatters";
import utils from "../../../../../utils";

const TopPackedProducts = ({ dateRange, dateRangeText, companyFilter }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { products, getProductById } = useProducts();
  const { getAggregatedAddedStock, loading } = useStockReport(dateRange);

  // Get top products and add weight information
  const topProductsData = getAggregatedAddedStock(companyFilter, products).slice(0, 5).map(product => {
    const productDetails = getProductById(product.productId);
    const productWeight = productDetails?.weight || 0;
    return {
      ...product,
      weight: productWeight,
      totalWeight: product.totalAddedStock * productWeight,
    };
  });

  const topProducts = topProductsData;

  const handleSeeFullReport = () => {
    const currentParams = searchParams.toString();
    navigate(`${stockReport}${currentParams ? `?${currentParams}` : ""}`);
  };

  const columns = [
    {
      title: t("product_name"),
      dataIndex: "productName",
      sorter: (a, b) => utils.antdTableSorter(a, b, "productName"),
    },
    {
      title: t("total_packed"),
      dataIndex: "totalAddedStock",
      sorter: (a, b) => utils.antdTableSorter(a, b, "totalAddedStock"),
    },
    {
      title: t("total_weight"),
      dataIndex: "totalWeight",
      render: (weight) => formatWeight(weight),
      sorter: (a, b) => utils.antdTableSorter(a, b, "totalWeight"),
    },
  ];

  if (!topProducts || topProducts.length === 0) {
    return (
      <Card
        title={t("top_packed_products")}
        extra={
          <Button type="link" onClick={handleSeeFullReport}>
            {t("see_full_report")}
          </Button>
        }
        loading={loading}
      >
        <span className="text-muted">{dateRangeText}</span>
        <div style={{ textAlign: "center", padding: "40px 0" }}>
          <span className="text-muted">{t("no_data_available")}</span>
        </div>
      </Card>
    );
  }

  return (
    <Card
      title={t("top_packed_products")}
      extra={
        <Button type="link" onClick={handleSeeFullReport}>
          {t("see_full_report")}
        </Button>
      }
      loading={loading}
    >
      <span className="text-muted">{dateRangeText}</span>
      <Table
        showSorterTooltip={false}
        columns={columns}
        dataSource={topProducts}
        rowKey="productId"
        pagination={false}
        scroll={{ x: 300 }}
        style={{ marginTop: 10 }}
      />
    </Card>
  );
};

export default TopPackedProducts;
